var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 7.8646,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 28C7 28 6.27949 24.6744 6.08503 22.5C5.89371 20.3607 6.08503 18 6.08503 18L9.02928 11.3754C9.67128 9.93093 11.1038 9 12.6845 9H23.4855C25.0663 9 26.4988 9.93093 27.1408 11.3754L30.085 18C30.085 18 30.3347 20.1702 30.085 22.5C29.8729 24.48 29 28 29 28H24.085V25H12.085L12 28H7ZM9 16L11.4869 11L24.6832 11L27 16H9ZM12.4999 20L8.08496 19L8.08496 22H13.085L12.4999 20ZM28.085 19L23.9999 20L23.085 22H28.085V19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCars);
export default __webpack_public_path__ + "static/media/cars.b2fb8d38eda5d02bdde89a337ba91b6c.svg";
export { ForwardRef as ReactComponent };